import { useState, useEffect } from 'react'
import { supabase } from './supabase'

const BROKERS = ['Ben Rogers','Jesse Roach','Mitch Speer']
const blankForm=()=>({client_name:'',channel:'Phone',description:'',assigned_handler:'',complaint_subject:'',vulnerability_flag:false,date_received:new Date().toISOString().split('T')[0]})

export function Complaints({ showToast, user }) {
  const [tab,setTab]=useState('lodge')
  const [complaints,setComplaints]=useState([])
  const [loading,setLoading]=useState(true)
  const [saving,setSaving]=useState(false)
  const [selected,setSelected]=useState(null)
  const [clients,setClients]=useState([])
  const [form,setForm]=useState(blankForm())
  const [noteText,setNoteText]=useState('')
  const [addingNote,setAddingNote]=useState(false)

  const CHANNELS=['Phone','Email','In Person','Written']
  const STATUSES=['Open','In Progress','Resolved','Escalated to AFCA']
  const STATUS_CLASS={'Open':'cs-open','In Progress':'cs-inprogress','Resolved':'cs-resolved','Escalated to AFCA':'cs-afca'}

  useEffect(()=>{
    loadComplaints()
    supabase.from('clients').select('id,company_name').order('company_name').then(({data})=>setClients(data||[]))
  },[])

  const loadComplaints=async()=>{
    setLoading(true)
    const {data}=await supabase.from('complaints').select('*').order('created_at',{ascending:false})
    setComplaints(data||[])
    setLoading(false)
  }

  const daysOpen=(d)=>!d?0:Math.floor((new Date()-new Date(d))/86400000)
  const businessDaysOpen=(d)=>{ if(!d) return 0; let count=0,dt=new Date(d); const today=new Date(); while(dt<today){dt.setDate(dt.getDate()+1);const dow=dt.getDay();if(dow!==0&&dow!==6)count++}; return count }
  const getDaysClass=(days)=>days<=20?'dc-green':days<=27?'dc-amber':'dc-red'

  const lodgeComplaint=async()=>{
    if(!form.client_name) return showToast('Client name required')
    if(!form.description) return showToast('Description required')
if(!form.assigned_handler) return showToast('Assigned handler required')
    if(!form.date_received) return showToast('Date received required')
    if(form.assigned_handler===form.complaint_subject) return showToast('⚠️ Handler cannot be the subject of the complaint')
    setSaving(true)
    const {error}=await supabase.from('complaints').insert({
      ...form,
      acknowledged_at:new Date().toISOString(),
      status:'Open',
      logged_by:user.name,
      internal_notes:[],
      audit_log:[{action:'Complaint lodged',by:user.name,at:new Date().toISOString()}]
    })
    if(error){showToast('Error saving complaint');setSaving(false);return}
    await loadComplaints()
    setForm(blankForm())
    showToast('✅ Complaint lodged — acknowledgement recorded')
    setSaving(false)
    setTab('track')
  }

const updateComplaint=async(id,updates,audit=null)=>{
    let finalUpdates=updates
    if(audit){
      const target=complaints.find(c=>c.id===id)
      const entry={...audit,by:user.name,at:new Date().toISOString()}
      finalUpdates={...updates,audit_log:[...(target?.audit_log||[]),entry]}
    }
    await supabase.from('complaints').update(finalUpdates).eq('id',id)
    setComplaints(prev=>prev.map(c=>c.id===id?{...c,...finalUpdates}:c))
    if(selected?.id===id) setSelected(prev=>({...prev,...finalUpdates}))
    showToast('Updated')
  }

  const addNote=async()=>{
    if(!noteText.trim()||!selected) return
    setAddingNote(true)
    const note={text:noteText,by:user.name,at:new Date().toISOString()}
    const updatedNotes=[...(selected.internal_notes||[]),note]
    await supabase.from('complaints').update({internal_notes:updatedNotes}).eq('id',selected.id)
    setComplaints(prev=>prev.map(c=>c.id===selected.id?{...c,internal_notes:updatedNotes}:c))
    setSelected(prev=>({...prev,internal_notes:updatedNotes}))
    setNoteText('')
    setAddingNote(false)
    showToast('Note added')
  }

  const resolveComplaint=async(outcome)=>{
    if(!selected) return
    const within5=businessDaysOpen(selected.date_received)<=5
    await updateComplaint(selected.id,{
      status:'Resolved',
      outcome,
      resolved_at:new Date().toISOString(),
response_sent_at:new Date().toISOString(),
      resolved_within_5_days:within5
    },{action:'Resolved',from:selected.status,to:'Resolved',outcome})
    showToast(`✅ Complaint resolved — ${outcome}`)
  }

  const open=complaints.filter(c=>c.status!=='Resolved')
  const resolved=complaints.filter(c=>c.status==='Resolved')
  const overdue=complaints.filter(c=>c.status!=='Resolved'&&daysOpen(c.date_received)>=28)

  return (
    <div>
      {/* Compliance blurb */}
      <div className="comp-blurb">
        <div className="comp-blurb-title">⚖️ Complaints Handling — Compliance Requirements</div>
        <div className="comp-blurb-grid">
          {[
            ['⏱️ 30-Day Resolution','All complaints must be resolved within 30 calendar days. If not, notify the client in writing and advise their AFCA rights immediately.'],
            ['📅 10-Business-Day Updates','Keep the complainant informed at least every 10 business days. Document every contact made.'],
            ['🚫 Handler Conflict Rule','The person whose conduct is subject of the complaint must not handle it. Assign an independent handler.'],
            ['✅ Immediate Acknowledgement','Acknowledge receipt promptly and provide information about your IDR process and timeframes.'],
            ['📄 Written Response',"Final response must include: outcome, reasons for decision, and client's right to escalate to AFCA (1800 931 678)."],
            ['🔶 Vulnerable Clients','Flag vulnerable clients (age, disability, language, financial distress, mental health). Apply additional care and reasonable accommodations.'],
          ].map(([title,text])=>(
            <div key={title} className="comp-blurb-item">
              <div className="comp-blurb-item-title">{title}</div>
              <div className="comp-blurb-item-text">{text}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Tabs */}
      <div className="comp-tabs">
        {[['lodge','+ Lodge & Assign'],['track','🔍 Track & Respond'],['register','📊 Register & Reporting']].map(([t,label])=>(
          <button key={t} className={`comp-tab ${tab===t?'active':''}`} onClick={()=>setTab(t)}>
            {label}
            {t==='track'&&open.length>0&&<span className="nav-badge" style={{marginLeft:6}}>{open.length}</span>}
            {t==='track'&&overdue.length>0&&<span className="nav-badge" style={{marginLeft:4,background:'var(--danger)'}}>{overdue.length} overdue</span>}
          </button>
        ))}
      </div>

      {/* ── LODGE TAB ── */}
      {tab==='lodge'&&(
        <div style={{maxWidth:720}}>
          <div className="comp-form-section">
            <div className="comp-form-section-title">📋 Complaint Details</div>
            <div className="form-grid">
              <div className="full">
                <label className="form-label">Client name *</label>
                <input className="form-input" list="client-list" value={form.client_name} onChange={e=>setForm(p=>({...p,client_name:e.target.value}))} placeholder="Start typing client name..." />
                <datalist id="client-list">{clients.map(c=><option key={c.id} value={c.company_name}/>)}</datalist>
              </div>
              <div>
                <label className="form-label">How was it received?</label>
                <select className="form-select" value={form.channel} onChange={e=>setForm(p=>({...p,channel:e.target.value}))}>{CHANNELS.map(c=><option key={c}>{c}</option>)}</select>
              </div>
             <div>
                <label className="form-label">Date received *</label>
                <input className="form-input" type="date" max={new Date().toISOString().split('T')[0]} value={form.date_received} onChange={e=>setForm(p=>({...p,date_received:e.target.value}))}/>
              </div>
              <div className="full">
                <label className="form-label">Description of complaint *</label>
                <textarea className="form-input" rows={3} value={form.description} onChange={e=>setForm(p=>({...p,description:e.target.value}))} placeholder="Describe the nature of the complaint in detail..." />
              </div>
            </div>
          </div>

          <div className="comp-form-section">
            <div className="comp-form-section-title">👤 Handler Assignment</div>
            <div className="form-grid">
              <div>
                <label className="form-label">Assign handler *</label>
                <select className="form-select" value={form.assigned_handler} onChange={e=>setForm(p=>({...p,assigned_handler:e.target.value}))}>
                  <option value="">Select handler...</option>
                  {BROKERS.map(b=><option key={b}>{b}</option>)}
                </select>
              </div>
              <div>
                <label className="form-label">Complaint is about (subject)</label>
                <select className="form-select" value={form.complaint_subject} onChange={e=>setForm(p=>({...p,complaint_subject:e.target.value}))}>
                  <option value="">Select or leave blank...</option>
                  {BROKERS.map(b=><option key={b}>{b}</option>)}
                  <option>General / Process</option>
                </select>
              </div>
              {form.assigned_handler&&form.complaint_subject&&form.assigned_handler===form.complaint_subject&&(
                <div className="full">
                  <div style={{background:'rgba(220,53,69,0.1)',border:'1.5px solid rgba(220,53,69,0.3)',borderRadius:9,padding:'10px 14px',fontSize:12,color:'var(--danger)',fontWeight:600}}>
                    ⚠️ Handler and complaint subject cannot be the same person. Please assign a different handler.
                  </div>
                </div>
              )}
              <div className="full">
                <label style={{display:'flex',alignItems:'center',gap:10,cursor:'pointer',padding:'10px 14px',background:'var(--surface2)',border:'1.5px solid var(--border)',borderRadius:9,userSelect:'none'}}>
                  <input type="checkbox" checked={form.vulnerability_flag} onChange={e=>setForm(p=>({...p,vulnerability_flag:e.target.checked}))} style={{accentColor:'#7c3aed',width:16,height:16}}/>
                  <div>
                    <div style={{fontSize:12,fontWeight:600,color:'#7c3aed'}}>🔶 Vulnerable Client Flag</div>
                    <div style={{fontSize:11,color:'var(--muted)',marginTop:2}}>Check if this client may be experiencing vulnerability (age, disability, language barriers, financial distress, mental health concerns)</div>
                  </div>
                </label>
              </div>
            </div>
          </div>

          <div style={{display:'flex',justifyContent:'flex-end',gap:8}}>
            <button className="btn btn-secondary" onClick={()=>setForm(blankForm())}>Clear</button>
            <button className="btn btn-danger" onClick={lodgeComplaint} disabled={saving||(form.assigned_handler&&form.assigned_handler===form.complaint_subject)}>{saving?'Lodging...':'⚖️ Lodge Complaint'}</button>
          </div>
        </div>
      )}

      {/* ── TRACK TAB ── */}
      {tab==='track'&&(
        <div style={{display:'grid',gridTemplateColumns:selected?'1fr 1.2fr':'1fr',gap:20}}>
          <div>
            {loading
              ?<div className="loading"><div className="spinner"/><span>Loading...</span></div>
              :open.length===0
              ?<div className="empty"><div className="empty-icon">✅</div><div className="empty-title">No open complaints</div><div className="empty-sub">All clear</div></div>
              :open.map(c=>{
                const days=daysOpen(c.date_received)
                return (
                  <div key={c.id} className={`comp-card ${selected?.id===c.id?'selected':''}`} onClick={()=>{setSelected(c);setNoteText('')}}>
                    <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:8,marginBottom:8}}>
                      <div>
                        <div style={{fontSize:13,fontWeight:700}}>{c.client_name}</div>
                        <div style={{fontSize:11,color:'var(--muted)',marginTop:2}}>{c.channel} · Logged by {c.logged_by} · Handler: {c.assigned_handler}</div>
                      </div>
                      <div style={{display:'flex',flexDirection:'column',alignItems:'flex-end',gap:4}}>
                        <span className={`days-counter ${getDaysClass(days)}`}>Day {days}/30</span>
                        {c.vulnerability_flag&&<span className="vuln-badge">🔶 Vulnerable</span>}
                      </div>
                    </div>
                    <div style={{fontSize:12,color:'var(--text)',marginBottom:8,lineHeight:1.5}}>{c.description?.substring(0,120)}{c.description?.length>120?'...':''}</div>
                    <div style={{display:'flex',gap:6,alignItems:'center'}}>
                      <span className={`comp-status ${STATUS_CLASS[c.status]}`}>{c.status}</span>
                      {days>=28&&c.status!=='Resolved'&&<span style={{fontSize:10,background:'rgba(220,53,69,0.12)',color:'var(--danger)',padding:'2px 8px',borderRadius:10,fontWeight:600}}>🔴 Delay notice required</span>}
                    </div>
                  </div>
                )
              })
            }
          </div>

          {selected&&(
            <div className="card" style={{padding:'20px',position:'sticky',top:80,maxHeight:'calc(100vh - 120px)',overflowY:'auto'}}>
<div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:16}}>
                <div style={{fontSize:14,fontWeight:700}}>{selected.client_name}</div>
                <button className="modal-close" onClick={()=>setSelected(null)}>✕</button>
              </div>

              <div style={{marginBottom:14,fontSize:11,color:'var(--muted)',display:'flex',flexWrap:'wrap',gap:'4px 12px'}}>
                <span>{selected.channel}</span>
                <span>Received {selected.date_received?new Date(selected.date_received).toLocaleDateString('en-AU',{day:'numeric',month:'short',year:'numeric'}):'—'}</span>
                <span>Logged by {selected.logged_by}</span>
                <span>Handler: {selected.assigned_handler}</span>
                {selected.complaint_subject&&<span>Subject: {selected.complaint_subject}</span>}
                {selected.vulnerability_flag&&<span className="vuln-badge">🔶 Vulnerable</span>}
              </div>

              <div style={{marginBottom:14}}>
                <label className="form-label" style={{marginBottom:6,display:'block'}}>Complaint description</label>
                <div style={{background:'var(--surface2)',border:'1px solid var(--border)',borderRadius:9,padding:'12px 14px',fontSize:13,lineHeight:1.6,color:'var(--text)',whiteSpace:'pre-wrap'}}>{selected.description||'—'}</div>
              </div>

              <div style={{marginBottom:12}}>
                <label className="form-label">Status</label>
                <select className="form-select" value={selected.status} onChange={e=>updateComplaint(selected.id,{status:e.target.value},{action:'Status changed',from:selected.status,to:e.target.value})}>
                  {STATUSES.map(s=><option key={s}>{s}</option>)}
                </select>
              </div>

              {selected.status==='Escalated to AFCA'&&(
                <div style={{marginBottom:12}}>
                  <label className="form-label">AFCA Reference Number</label>
                  <input className="form-input" value={selected.afca_reference||''} placeholder="e.g. AFCA-2024-XXXXX" onChange={e=>updateComplaint(selected.id,{afca_reference:e.target.value,afca_escalated_at:new Date().toISOString()})}/>
                </div>
              )}

<div style={{marginBottom:12}}>
                <label className="form-label">Date received</label>
                <input className="form-input" type="date" max={new Date().toISOString().split('T')[0]} value={selected.date_received||''} onChange={e=>updateComplaint(selected.id,{date_received:e.target.value},{action:'Date received amended',from:selected.date_received,to:e.target.value})}/>
              </div>

              <div style={{marginBottom:12}}>
                <label className="form-label">Last client contact</label>
                <input className="form-input" type="date" value={selected.last_client_contact||''} onChange={e=>updateComplaint(selected.id,{last_client_contact:e.target.value},{action:'Client contact logged',to:e.target.value})}/>
              </div>

              <div style={{marginBottom:16}}>
                <label className="form-label" style={{marginBottom:6,display:'block'}}>Internal notes</label>
                <textarea className="form-input" rows={2} value={noteText} onChange={e=>setNoteText(e.target.value)} placeholder="Add a note..." style={{marginBottom:6}}/>
                <button className="btn btn-secondary btn-sm" onClick={addNote} disabled={addingNote||!noteText.trim()}>{addingNote?'Adding...':'Add note'}</button>
                {(selected.internal_notes||[]).length>0&&(
                  <div style={{marginTop:10,display:'flex',flexDirection:'column',gap:6}}>
                    {[...(selected.internal_notes||[])].reverse().map((n,i)=>(
                      <div key={i} style={{background:'var(--surface2)',border:'1px solid var(--border)',borderRadius:8,padding:'8px 12px'}}>
                        <div style={{fontSize:12,lineHeight:1.5}}>{n.text}</div>
                        <div style={{fontSize:10,color:'var(--muted)',marginTop:4}}>{n.by} · {new Date(n.at).toLocaleDateString('en-AU',{day:'numeric',month:'short',hour:'2-digit',minute:'2-digit'})}</div>
                      </div>
                    ))}
                  </div>
)}
              </div>

              {(selected.audit_log||[]).length>0&&(
                <div style={{marginBottom:16}}>
                  <label className="form-label" style={{marginBottom:6,display:'block'}}>Activity log</label>
                  <div style={{display:'flex',flexDirection:'column',gap:4}}>
                    {[...(selected.audit_log||[])].reverse().map((a,i)=>(
                      <div key={i} style={{fontSize:11,color:'var(--muted)',display:'flex',gap:6,lineHeight:1.5}}>
                        <span style={{color:'var(--text)',fontWeight:600}}>{a.action}</span>
                        {a.from&&a.to&&<span>{a.from} → {a.to}</span>}
                        {a.outcome&&!a.from&&<span>{a.outcome}</span>}
                        <span style={{marginLeft:'auto',whiteSpace:'nowrap'}}>{a.by} · {new Date(a.at).toLocaleDateString('en-AU',{day:'numeric',month:'short',hour:'2-digit',minute:'2-digit'})}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {selected.status!=='Resolved'&&(
                <div style={{borderTop:'1.5px solid var(--border)',paddingTop:14}}>
                  <div style={{fontSize:11,fontWeight:700,color:'var(--muted)',textTransform:'uppercase',letterSpacing:'.4px',marginBottom:8}}>Resolve complaint</div>
                  <div style={{fontSize:11,color:'var(--muted)',marginBottom:10,lineHeight:1.6}}>Written response must include: outcome, reasons, and AFCA rights (1800 931 678).</div>
                  <div style={{display:'flex',flexDirection:'column',gap:6}}>
                    {['Upheld','Partially Upheld','Not Upheld'].map(o=>(
                      <button key={o} className="btn btn-secondary btn-sm" style={{justifyContent:'flex-start',gap:8}} onClick={()=>resolveComplaint(o)}>
                        {o==='Upheld'?'✅':o==='Partially Upheld'?'⚡':'❌'} Resolve — {o}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {selected.status==='Resolved'&&(
                <div style={{background:'rgba(30,61,48,0.08)',border:'1.5px solid var(--forest-border)',borderRadius:10,padding:'12px 14px'}}>
                  <div style={{fontSize:12,fontWeight:700,color:'var(--forest)',marginBottom:4}}>✅ Resolved — {selected.outcome}</div>
                  <div style={{fontSize:11,color:'var(--muted)'}}>{selected.resolved_at?new Date(selected.resolved_at).toLocaleDateString('en-AU',{day:'numeric',month:'short',year:'numeric'}):'—'}{selected.resolved_within_5_days&&' · Resolved within 5 business days'}</div>
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {/* ── REGISTER TAB ── */}
      {tab==='register'&&(
        <div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12,marginBottom:20}}>
            <div className="stat-mini"><div className="stat-mini-label">Total complaints</div><div className="stat-mini-value">{complaints.length}</div></div>
            <div className="stat-mini"><div className="stat-mini-label">Open</div><div className="stat-mini-value" style={{color:'var(--info)'}}>{open.length}</div></div>
            <div className="stat-mini"><div className="stat-mini-label">Overdue (&gt;28 days)</div><div className="stat-mini-value" style={{color:'var(--danger)'}}>{overdue.length}</div></div>
            <div className="stat-mini"><div className="stat-mini-label">Resolved</div><div className="stat-mini-value" style={{color:'var(--forest)'}}>{resolved.length}</div></div>
          </div>
          <div className="card">
            <div className="card-header">
              <div className="card-title">Complaints Register</div>
              <div style={{fontSize:11,color:'var(--muted)'}}>Required for AFCA, ASIC and Steadfast reporting</div>
            </div>
            <div className="reg-row reg-header"><span>Client</span><span>Received</span><span>Handler</span><span>Status</span><span>Outcome</span><span>Days Open</span></div>
            {complaints.length===0
              ?<div className="empty"><div className="empty-icon">📋</div><div className="empty-title">No complaints recorded</div></div>
              :complaints.map(c=>{
                const days=daysOpen(c.date_received)
                return (
                  <div key={c.id} className="reg-row" style={{cursor:'pointer'}}
                    onClick={()=>{setSelected(c);setNoteText('');setTab('track')}}
                    onMouseEnter={e=>e.currentTarget.style.background='var(--surface2)'}
                    onMouseLeave={e=>e.currentTarget.style.background=''}
                  >
                    <div>
                      <div style={{fontWeight:600,fontSize:12}}>{c.client_name}</div>
                      <div style={{fontSize:10,color:'var(--muted)'}}>{c.channel}{c.vulnerability_flag?' · 🔶 Vulnerable':''}</div>
                    </div>
                    <div style={{fontSize:12}}>{new Date(c.date_received).toLocaleDateString('en-AU',{day:'numeric',month:'short',year:'numeric'})}</div>
                    <div style={{fontSize:12}}>{c.assigned_handler?.split(' ')[0]||'—'}</div>
                    <div><span className={`comp-status ${STATUS_CLASS[c.status]}`}>{c.status}</span></div>
                    <div style={{fontSize:12,color:c.outcome?'var(--forest)':'var(--muted)'}}>{c.outcome||'—'}</div>
                    <div><span className={`days-counter ${getDaysClass(days)}`}>{days}</span></div>
                  </div>
                )
              })
            }
          </div>
        </div>
      )}
    </div>
  )
}
